// extracted by mini-css-extract-plugin
module.exports = {"container":"InstitutionAdmin_container__1XDau","memberList":"InstitutionAdmin_memberList__JqVRW"};